import { useState } from "react";
import { useToast } from "@/components/common/Toast";

interface RuleStatusToggleProps {
	ruleId: string;
	currentStatus: "ENABLED" | "DISABLED";
	onStatusChange: (ruleId: string, newStatus: "ENABLED" | "DISABLED") => void;
}

const RuleStatusToggle: React.FC<RuleStatusToggleProps> = ({
	ruleId,
	currentStatus,
	onStatusChange
}) => {
	const { error } = useToast();
	const [isLoading, setIsLoading] = useState(false);
	const [status, setStatus] = useState(currentStatus);

	const handleToggle = async () => {
		if (isLoading) return;

		setIsLoading(true);
		const newStatus = status === "ENABLED" ? "DISABLED" : "ENABLED";

		try {
			setStatus(newStatus);
			onStatusChange(ruleId, newStatus);
		} catch (_error) {
			error("Failed to update rule status");
		} finally {
			setIsLoading(false);
		}
	};

	const isEnabled = status === "ENABLED";

	return (
		<button
			type="button"
			onClick={handleToggle}
			disabled={isLoading}
			className={`w-12 h-6 flex items-center rounded-full p-1 ${
				isEnabled ? "bg-green-500" : "bg-gray-300"
			} transition-colors duration-300 focus:outline-none ${
				isLoading ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
			}`}
			title={`${isEnabled ? "Enabled" : "Disabled"} - Click to toggle`}
		>
			<span
				className={`bg-white w-4 h-4 rounded-full shadow-md transform ${
					isEnabled ? "translate-x-6" : "translate-x-0"
				} transition-transform duration-300`}
			/>
		</button>
	);
};

export default RuleStatusToggle;
